"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQuery = void 0;
var _set2 = _interopRequireDefault(require("lodash/set"));
var _Condition = require("./CustomQueryForm/FilterForm/Condition");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var conditions = {};
var _loop = function _loop() {
  var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
    type = _Object$entries$_i[0],
    value = _Object$entries$_i[1];
  var list = {};
  value.forEach(function (item) {
    list[item.value] = item;
  });
  conditions[type] = list;
};
for (var _i = 0, _Object$entries = Object.entries(_Condition.allConditions); _i < _Object$entries.length; _i++) {
  _loop();
}
var getQuery = exports.getQuery = function getQuery(settings, prettify) {
  var obj = {};
  var variableRegex = /^variables\d+:/;
  var symbols = {
    '[': '***>>>',
    ']': '<<<***'
  };
  function encode(str) {
    for (var _i2 = 0, _Object$entries2 = Object.entries(symbols); _i2 < _Object$entries2.length; _i2++) {
      var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
        key = _Object$entries2$_i[0],
        value = _Object$entries2$_i[1];
      str = str.split(key).join(value);
    }
    if (str.includes('{')) {
      str = str.split('.').join('<<**>>');
    }
    return str;
  }
  function decode(str) {
    for (var _i3 = 0, _Object$entries3 = Object.entries(symbols); _i3 < _Object$entries3.length; _i3++) {
      var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i3], 2),
        key = _Object$entries3$_i[0],
        value = _Object$entries3$_i[1];
      str = str.split(value).join(key);
    }
    str = str.split('<<**>>').join('.');
    return str;
  }
  function removeBrackets(str) {
    // remove all line breaks
    str = str.replace(/(\r\n|\n|\r)/gm, '');

    // keep the part inside quotes unchanged
    var strings = [];
    str = str.replace(/("[\w ]+")/g, function (_, string) {
      strings.push(string);
      return '#string#';
    });

    // keep the part inside parentheses unchanged
    var bodies = [];
    str = str.replace(/\(([^()]*)\)/g, function (_, body) {
      bodies.push(body);
      return '()';
    });
    var regex = /\{([^}]+)\}/g;
    while (regex.test(str)) {
      str = str.replace(regex, '.$1');
    }
    return str.replace(/\(\)/g, function () {
      return '(' + bodies.shift() + ')';
    }).replace(/\s+/g, '').replace(/#string#/g, function () {
      return strings.shift();
    });
  }

  // sort just to preserve query even if the column order has been changed
  var columns = _toConsumableArray(settings.columns).sort(function (a, b) {
    return a.name.localeCompare(b.name);
  });

  // Set variables
  (function () {
    var variablesColumns = columns.filter(function (column) {
      return variableRegex.test(column.query);
    });
    var sections = {};
    var _iterator = _createForOfIteratorHelper(variablesColumns),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var column = _step.value;
        var _column$query$split = column.query.split('.variables.'),
          _column$query$split2 = _slicedToArray(_column$query$split, 2),
          left = _column$query$split2[0],
          right = _column$query$split2[1];
        sections[left] = sections[left] || [];
        sections[left].push("\"".concat(right, "\""));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    for (var _i4 = 0, _Object$entries4 = Object.entries(sections); _i4 < _Object$entries4.length; _i4++) {
      var _Object$entries4$_i = _slicedToArray(_Object$entries4[_i4], 2),
        name = _Object$entries4$_i[0],
        variables = _Object$entries4$_i[1];
      (0, _set2["default"])(obj, removeBrackets("".concat(name, ".variables(name: ***>>>").concat(variables.join(','), "<<<***)")));
    }
  })();

  // Set other fields
  (function () {
    var otherColumns = columns.filter(function (column) {
      return !column.isAction && !variableRegex.test(column.query);
    });
    var _iterator2 = _createForOfIteratorHelper(otherColumns),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var column = _step2.value;
        var path = encode(column.query || column.name);
        (0, _set2["default"])(obj, removeBrackets(path));
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  })();

  // Set key field
  (0, _set2["default"])(obj, 'pawn.pawnId');
  function getFields(node) {
    var str = '';
    for (var _i5 = 0, _Object$entries5 = Object.entries(node); _i5 < _Object$entries5.length; _i5++) {
      var _Object$entries5$_i = _slicedToArray(_Object$entries5[_i5], 2),
        key = _Object$entries5$_i[0],
        value = _Object$entries5$_i[1];
      if (!value) {
        str += ' ' + key;
      } else {
        str += ' ' + key + ' { ' + getFields(value) + ' }';
      }
    }
    return str;
  }

  // Get filter
  var constantFilter = getFormattedConstantFilter(settings.filter);
  var filter = constantFilter ? "{\n            AND: [\n                ".concat(constantFilter, "\n                $filter\n            ]\n        }") : '$filter';

  // let condition = '';
  //     if (settings.projectId) {
  //         if (settings.hasIdentifiable) {
  //             condition += `\nandHasAll: [{ permission: "quest.view_identifiable_data", groupId: ${settings.projectId} }]`;
  //         }
  //
  //         condition += `\nandHasAny: [
  //     { permission: "quest.tables", groupId: ${settings.projectId} }
  //     { permission: "quest.admin", groupId: ${settings.projectId} }
  // ]`;
  //     }

  var extraParams = [];
  if (settings.onlyCompleted) {
    extraParams.push('assignmentStatus: COMPLETED');
  }
  if (settings.includeArchived) {
    extraParams.push('includeArchivedPawns: true');
  }
  var applyPawnContextStr = settings.applyPawnContext === false ? ', applyPawnContext: false' : '';
  var extraParamsStr = extraParams.length > 0 ? ", ".concat(extraParams.join(', ')) : '';
  var query = decode("query($deploymentId: [Int]!, $projectId: [Int]!, $limit: Int, $offset: Int, $orderBy: [OrderBy], $filter: Filter, $metrics: [String]) {\n        flows(\n            as: ANY\n            ".concat(settings.includeIdentifiable ? 'andHasAll: [{ permission: "quest.view_identifiable_data", groupId: $projectId }]' : '', "\n            andHasAny: [\n                { permission: \"quest.view_data\", groupId: $projectId }\n                { permission: \"quest.admin\", groupId: $projectId }\n            ]\n        ) {\n            assignmentProgressList(deploymentId: $deploymentId, limit: $limit, offset: $offset, orderBy: $orderBy, filter: ").concat(filter, " ").concat(applyPawnContextStr, " ").concat(extraParamsStr, ") {\n                assignmentProgressId\n                language\n                surveylist {\n                    surveylistHandle\n                }\n                deployment(includeAllRelated: true) {\n                    label\n                    timepoint\n                }\n                pawn(context: GLOBAL) {\n                    ").concat(getFields(obj), "\n                }\n                status\n                variables(codedValues: ").concat(settings.codedValues, ", includeIdentifiable: ").concat(settings.includeIdentifiable, ", name: $metrics)\n            }\n            totalCount: assignmentProgressCount(deploymentId: $deploymentId ").concat(constantFilter ? ", filter: ".concat(constantFilter) : '', " ").concat(applyPawnContextStr, " ").concat(extraParamsStr, ")\n            filteredCount: assignmentProgressCount(deploymentId: $deploymentId, filter: ").concat(filter, " ").concat(applyPawnContextStr, " ").concat(extraParamsStr, ")\n        }\n    }"));
  return prettify ? prettify(query) : query;
};
function getFormattedConstantFilter(filter) {
  function traverse(node) {
    if (!node) {
      return '';
    }
    var hasConditions = node.aggregation && node.conditions.filter(function (item) {
      return item.column;
    }).length > 0;
    if (node.aggregation === 'all' && hasConditions) {
      return "{ AND: [ ".concat(node.conditions.map(traverse).join(' '), " ] }");
    }
    if (node.aggregation === 'any' && hasConditions) {
      return "{ OR: [ ".concat(node.conditions.map(traverse).join(' '), " ] }");
    }
    if (node.column) {
      return '{ ' + conditions[node.column.type][node.operator].getCondition({
        field: 'pawn.' + node.column.id,
        value: node.value
      }) + ' }';
    }
    return '';
  }
  return traverse(filter);
}